import $ from 'jquery';
import { loadStripeJS } from './index';
import { onErrorShowMessage } from '~src/errors';
import Swal from 'sweetalert2';
import { refreshAiCredits } from '~core/payments';

/**
 * Helper function to show checkout modal (fallback flow)
 * @param {string} checkoutUrl - Checkout URL
 * @param {Object} selectedModule - Selected module info
 * @param {number} totalCredits - Total credits
 */
const showCheckoutModal = async (
  checkoutSession,
  selectedModule,
  totalCredits
) => {
  try {
    await loadStripeJS();

    // Create and show Bootstrap modal with embedded checkout URL
    const modalHtml = `
        <div class="modal fade" id="checkoutModal" tabindex="-1" role="dialog" aria-labelledby="checkoutModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="checkoutModalLabel">
                  Completa il tuo acquisto di: <span class="text-primary">${selectedModule.name}</span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body p-0" style="height: 80vh;">
                <div id="checkout-container" style="height: 100%;"></div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-link" data-dismiss="modal">Annulla</button>
              </div>
            </div>
          </div>
        </div>
      `;

    // Append modal to body
    const modalElement = document.createElement('div');
    modalElement.innerHTML = modalHtml;
    document.body.appendChild(modalElement);

    // Initialize and show the modal
    const $modal = $('#checkoutModal');

    // Close the loading SweetAlert before showing the modal
    Swal.close();

    $modal.modal({ backdrop: 'static', keyboard: false }, 'show');

    // Initialize Stripe embedded checkout
    const publishableKeys = {
      dev: 'pk_test_TvrUNX6ojFYWl6CdNOBfGmKw',
      prod: 'pk_live_l03AO8xqMuESwvU4CKFkWKRu',
    };
    const stripe = window.Stripe(publishableKeys[process.env.ENVIRONMENT]);

    const options = {
      fetchClientSecret: () => {
        return checkoutSession.session.client_secret;
      },
      onComplete: async () => {
        $modal.modal('hide');
        await refreshAiCredits(totalCredits);
      },
    };

    const checkout = await stripe.initEmbeddedCheckout(options);

    // Mount Checkout
    checkout.mount('#checkout-container');

    // Add custom CSS to make Stripe elements fill the container
    const styleElement = document.createElement('style');
    styleElement.textContent = `
        #checkout-container {
          display: flex;
          flex-direction: column;
        }
        
        #checkout-container iframe {
          flex: 1;
          min-height: 100%;
        }
      `;
    document.head.appendChild(styleElement);

    // Clean up modal and Stripe checkout when closed
    $modal.on('hidden.bs.modal', function () {
      checkout.destroy();
      $modal.remove();
      styleElement.remove(); // Remove the custom styles when modal is closed
    });
  } catch (error) {
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Errore',
      text: 'Si è verificato un errore durante il caricamento di Stripe.',
      confirmButtonColor: '#278e8e',
    });
    console.error('Stripe loading error:', error);
  }
};

export default showCheckoutModal;
